export enum BriefingSortByEnum {
    PUBLISHED_DATE_NEWEST = 'PUBLISHED_DATE_NEWEST',
    PUBLISHED_DATE_OLDEST = 'PUBLISHED_DATE_OLDEST',
    SENTIMENT = 'SENTIMENT',
    TITLE = 'TITLE',
    TAGS = 'TAGS',
    AUTHOR = 'AUTHOR',
    MEDIA_TYPE = 'MEDIA_TYPE',
    POTENTIAL_AUDIENCE_MOST = 'POTENTIAL_AUDIENCE_MOST',
    POTENTIAL_AUDIENCE_LEAST = 'POTENTIAL_AUDIENCE_LEAST',
    MANUAL = 'MANUAL',
    DOMAIN_AUTHORITY = 'DOMAIN_AUTHORITY',
    ENGAGEMENT_MOST = 'ENGAGEMENT_MOST'
}
